<template>
    <div class="box">
        <template v-if="hasActive">
            <div class="box-header">
                <h3 class="box-title">{{resource('DmVisualizer_Overview_BoxTitle')}}</h3>
                <br />
                <span v-html="titleBodyText"></span>
            </div>

            <div class="box-body">
                <scenario-active-overview
                    v-bind:scenario-batches="activeScenarioBatchList.scenarioBatches"
                    @batches-updated="replaceActiveScenarioBatches($event.scenarioId, $event.batches)"
                >
                </scenario-active-overview>
            </div>
        </template>

        <template v-if="hasHistory">
            <div class="box-header">
                <h3 class="box-title">{{resource('DmVisualizer_Overview_History_BoxTitle')}}</h3>
            </div>
            <div class="box-body">
                <div class="row">
                    <div class="col-6">
                        <scenario-historical-overview
                                v-bind:scenario-batches="historicalScenarioBatchList.scenarioBatches"
                                v-bind:from-date="historicalScenarioBatchList.periodStart"
                                v-bind:to-date="historicalScenarioBatchList.periodEnd"
                                v-bind:target-date="historicalScenarioBatchList.targetDate"
                        ></scenario-historical-overview>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import formatDateMixin from '../Mixins/format-date-mixin';
    import sortScenariosMixin from '../Mixins/sort-scenarios-mixin';
    import resourceMixin from '../../../Util/Mixins/resources';
    
    import sprintf from 'sprintf';
    import dmVisualizerApi from '../../../Api/dm-visualizer';
    import growler from "../../../Util/growler";

    import ScenarioList from "./ScenarioList.vue";
    import ScenarioActiveOverview from "./Overview/ScenarioActiveOverview.vue";
    import ScenarioBatchListItem from "./Overview/ScenarioBatchListItem.vue";
    import ScenarioHistoricalOverview from "./Overview/ScenarioHistoricalOverview.vue";
    
    export default {
        name: "dm-visualizer-overview",
        mixins: [sortScenariosMixin, resourceMixin, formatDateMixin],
        components: {
            ScenarioList,
            ScenarioBatchListItem,
            ScenarioActiveOverview,
            ScenarioHistoricalOverview
        },
        beforeCreate() {
            const vm = this;

            dmVisualizerApi.getCustomerContactEmail().then(
                email => vm.customerContactEmail = email,
                () => {}
            );
            
            dmVisualizerApi.listActiveBatches()
                .then(
                    scenarioBatchList => vm.activeScenarioBatchList = scenarioBatchList,
                    err => growler.error(err.join('\n'))
                );

            dmVisualizerApi.listHistoricalBatches()
                .then(
                    scenarioBatchList => vm.historicalScenarioBatchList = scenarioBatchList,
                    err => growler.error(err.join('\n'))
                );
        },
        methods: {
            replaceActiveScenarioBatches(scenarioId, batches){
                const vm = this;
                
                //Replacing all batches with our given scenarioId should do the trick and trigger a re-render
                const newScenarioBatches = vm.activeScenarioBatchList.scenarioBatches
                    .filter(b => b.scenarioId !== scenarioId);
                
                newScenarioBatches.push(...batches);
                vm.activeScenarioBatchList.scenarioBatches = newScenarioBatches;
            },
        },
        computed: {
            hasHistory(){
                return this.historicalScenarioBatchList.scenarioBatches && 
                    this.historicalScenarioBatchList.scenarioBatches.length;
            },
            hasActive(){
                return this.activeScenarioBatchList.scenarioBatches &&
                    this.activeScenarioBatchList.scenarioBatches.length;
            },
            titleBodyText(){
                //Can't format a string with date we don't have
                if(!this.hasActive) return undefined;
                
                const baseString = this.resource('DmVisualizer_Overview_BoxTitleBody');
                const {periodStart, periodEnd, targetDate} = this.activeScenarioBatchList;
                
                return sprintf(
                    baseString,
                    this.formatDate(periodStart),
                    this.formatDate(periodEnd),
                    this.formatDate(targetDate),
                    this.customerContactEmail ? `<a href="mailto:${this.customerContactEmail}">${this.customerContactEmail}</a>` : ''
                )
            }
        },
        data: () => ({
            activeScenarioBatchList: [],
            historicalScenarioBatchList: {},
            customerContactEmail: undefined
        })
    };
</script>
